module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cartographies":"Cartographies","functions":"Functions","nodes":"Nodes","searchBar":"search","subjects":"Subjects"},"fr":{"cartographies":"Cartographies","functions":"Fonctions","nodes":"Noeuds","searchBar":"Recherche","subjects":"Sujets"}}')
  delete Component.options._Ctor
}
